import _ from "lodash";

export const STORE_MAINTENANCE_PAGE_SIZE = 1000;
export const STORE_UNIVERSE_PAGE_SIZE = 500;
export const STORE_UNIVERSE_SUMMARY_PAGE_SIZE = 1000;
export const STORE_UNIVERSE_MAX_IN_FLIGHT = 3;

export const pageOffsetsFrom = (startOffset, totalItemsCount, pageStride) => {
    const offsets = [];
    if (!pageStride) return offsets;
    for (let offset = startOffset; offset < totalItemsCount; offset += pageStride) {
        offsets.push(offset);
    }
    return offsets;
};

export const remainingPageOffsets = (totalItemsCount, pageSize) =>
    pageOffsetsFrom(pageSize, totalItemsCount, pageSize);

export const fetchStoreUniversePages = async ({
                                                  fetchPage,
                                                  offsets,
                                                  pageSize,
                                                  totalItemsCount,
                                                  loadedItemsCount = 0,
                                                  onProgress,
                                              }) => {
    const items = [];
    const progress = {loadedItemsCount};
    const reportPage = (page) => {
        progress.loadedItemsCount += page?.items?.length ?? 0;
        onProgress?.({loadedItemsCount: progress.loadedItemsCount, totalItemsCount});
        return page;
    };
    for (const offsetBatch of _.chunk(offsets, STORE_UNIVERSE_MAX_IN_FLIGHT)) {
        const pages = await Promise.all(offsetBatch.map(offset => fetchPage(offset, pageSize).then(reportPage)));
        items.push(...pages.flatMap(page => page?.items ?? []));
    }
    return items;
};

export const fetchAllStoreUniversePages = async ({
                                                     fetchPage,
                                                     pageSize = STORE_UNIVERSE_PAGE_SIZE,
                                                     onProgress,
                                                 }) => {
    const firstPage = await fetchPage(0, pageSize);
    const firstPageItems = firstPage?.items ?? [];
    const totalItemsCount = firstPage?.totalItemsCount ?? 0;
    onProgress?.({loadedItemsCount: firstPageItems.length, totalItemsCount});

    const remainingItems = await fetchStoreUniversePages({
        fetchPage,
        offsets: remainingPageOffsets(totalItemsCount, firstPageItems.length),
        pageSize,
        totalItemsCount,
        loadedItemsCount: firstPageItems.length,
        onProgress,
    });
    return [...firstPageItems, ...remainingItems];
};
